// lib/emails/mailSuche.ts
// #543: Suche in der Mailliste. Vorher nur Betreff, Absender-ADRESSE und Empfänger — der
// Absendername („Görnert Immobilien GbR“) fehlte, und „ö“ traf kein „oe“ (goernert@…).
// Jetzt: alle sichtbaren Felder plus Textanfang, Umlaute gleichwertig (ö = oe, ß = ss),
// mehrere Wörter müssen alle vorkommen (in beliebigen Feldern).

/** Kleinbuchstaben, Umlaute als ae/oe/ue, ß als ss, Akzente weg. */
export function suchNormal(s: string | null | undefined): string {
  return String(s ?? '').toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[̀-ͯ]/g, '');
}

export interface MailSuchFelder {
  betreff?: string | null; von?: string | null; von_name?: string | null;
  an?: string; cc?: string; text_inhalt?: string | null;
  namen?: (string | null | undefined)[];
}

/** Trifft die Suche diese Mail? Jedes Wort muss in mindestens einem Feld stehen. */
export function mailTrifft(felder: MailSuchFelder, suche: string): boolean {
  const woerter = suchNormal(suche).split(/\s+/).filter(Boolean);
  if (woerter.length === 0) return true;
  const heuhaufen = suchNormal([
    felder.betreff, felder.von, felder.von_name, felder.an, felder.cc, ...(felder.namen ?? []),
    (felder.text_inhalt ?? '').slice(0, 20000),
  ].filter(Boolean).join('\n'));
  return woerter.every((w) => heuhaufen.includes(w));
}
